<template>
  <AppLayout :title="title">
    <div class="grid grid-cols-4 gap-6 space-y-0 lg:gap-12">
      <Highlight
        label="Advisors"
        :count="highlights.now.advisors_count"
        :previous-count="highlights.previous.advisors_count"
        difference-label="from previous 30 days"
      >
        <div class="space-y-2">
          <div class="flex items-center justify-between">
            <div>Acceptances</div>
            <div>0</div>
          </div>
          <div class="flex items-center justify-between">
            <div>New</div>
            <div>0</div>
          </div>
          <div class="flex items-center justify-between">
            <div>Active</div>
            <div>0</div>
          </div>
        </div>
      </Highlight>

      <Highlight label="Views" :count="0" :previous-count="0" difference-label="from previous 30 days">
        <div class="space-y-2">
          <div class="flex items-center justify-between">
            <div>Explore</div>
            <div>0</div>
          </div>
          <div class="flex items-center justify-between">
            <div>Inspires</div>
            <div>0</div>
          </div>
          <div class="flex items-center justify-between">
            <div>Copilot</div>
            <div>0</div>
          </div>
          <div class="flex items-center justify-between">
            <div>Embeds</div>
            <div>0</div>
          </div>
        </div>
      </Highlight>

      <Highlight label="Clicks" :count="0" :previous-count="0" difference-label="from previous 30 days">
        <div class="space-y-2">
          <div class="flex items-center justify-between">
            <div>Explore</div>
            <div>0</div>
          </div>
          <div class="flex items-center justify-between">
            <div>Inspires</div>
            <div>0</div>
          </div>
          <div class="flex items-center justify-between">
            <div>Copilot</div>
            <div>0</div>
          </div>
          <div class="flex items-center justify-between">
            <div>Embeds</div>
            <div>0</div>
          </div>
        </div>
      </Highlight>

      <Highlight label="Leads" :count="0" :previous-count="0" difference-label="from previous 30 days">
        <div class="space-y-2">
          <div class="flex items-center justify-between">
            <div>Explore</div>
            <div>0</div>
          </div>
          <div class="flex items-center justify-between">
            <div>Inspires</div>
            <div>0</div>
          </div>
          <div class="flex items-center justify-between">
            <div>Copilot</div>
            <div>0</div>
          </div>
          <div class="flex items-center justify-between">
            <div>Embeds</div>
            <div>0</div>
          </div>
        </div>
      </Highlight>
    </div>

    <DataTable
      title="Partners"
      endpoint="copilot-insights/views-by-partner"
      :per-page="10"
      :sort="{ views: 'desc' }"
      class="mt-6 lg:mt-12"
    >
      <template v-slot:rows="rows">
        <DataTableRow v-for="(row, i) in rows" :key="i" :row="row">
          <DataTableColumn title="Partner" sortable="name">
            <router-link :to="{ name: 'copilot-insights.partner', params: { id: row.partner.id } }">{{
              row.partner.name
            }}</router-link>
          </DataTableColumn>
          <DataTableColumn title="Advisors" sortable="advisors_count">{{
            row.advisors_count | number
          }}</DataTableColumn>
          <DataTableColumn title="Views" sortable="views">{{ row.views | number }}</DataTableColumn>
          <DataTableColumn title="Clicks" sortable="clicks">{{ row.clicks | number }}</DataTableColumn>
          <DataTableColumn title="Leads" sortable="leads"
            >{{ (row.lead_intents + row.leads) | number }}
            <span class="text-sm text-supplement"
              >({{ row.lead_intents | number }} / {{ row.leads | number }})</span
            ></DataTableColumn
          >
        </DataTableRow>
      </template>
    </DataTable>

    <DataTable title="Advisors" endpoint="copilot-insights/views-by-user" :per-page="10" :sort="{ views: 'desc' }">
      <template v-slot:rows="rows">
        <DataTableRow v-for="(row, i) in rows" :key="i" :row="row">
          <DataTableColumn title="Partner" sortable="full_name">
            <div class="flex items-center">
              <Avatar
                :label="row.user.initials"
                :image-url="row.user.personal_photo && row.user.personal_photo.thumb_url"
                class="mr-5"
              />
              <div>
                <router-link :to="{ name: 'copilot-insights.user', params: { id: row.user.id } }">
                  <span v-if="row.user.full_name">{{ row.user.full_name }}</span>
                  <span v-else>Unknown</span>
                  <div class="text-supplement">{{ row.user.email }}</div>
                </router-link>
              </div>
            </div>
          </DataTableColumn>
          <DataTableColumn title="Partners" sortable="partners_count">{{
            row.partners_count | number
          }}</DataTableColumn>
          <DataTableColumn title="Views" sortable="views">{{ row.views | number }}</DataTableColumn>
          <DataTableColumn title="Clicks" sortable="clicks">{{ row.clicks | number }}</DataTableColumn>
          <DataTableColumn title="Leads" sortable="leads"
            >{{ (row.lead_intents + row.leads) | number }}
            <span class="text-sm text-supplement"
              >({{ row.lead_intents | number }} / {{ row.leads | number }})</span
            ></DataTableColumn
          >
        </DataTableRow>
      </template>
    </DataTable>

    <div>Collaborators</div>
    <div>Consortium</div>
    <div>Host Agencies</div>

    <div class="mt-12 grid gap-12 space-y-0 md:grid-cols-3">
      <Card title="Sources">
        <div class="grid grid-cols-2">
          <div>Direct / None</div>
          <div>1M</div>
          <div>Google</div>
          <div>208k</div>
          <div>Twitter</div>
          <div>56k</div>
          <div>Facebook</div>
          <div>22.3k</div>
          <div>Reddit</div>
          <div>20k</div>
        </div>
      </Card>

      <Card title="Countries">
        <div>...</div>
      </Card>

      <Card title="Languages">
        <div>...</div>
      </Card>
    </div>
  </AppLayout>
</template>

<script>
import Avatar from "@/components/Avatar.vue"
import Highlight from "@/components/Highlight.vue"

export default {
  components: {
    Avatar,
    Highlight
  },
  metaInfo() {
    return { title: this.title }
  },
  data: () => ({
    loading: true,
    title: "Insights",
    highlights: null
  }),
  async created() {
    const { data: highlights } = await this.$api.get(`users/highlights`)
    this.highlights = highlights
    this.loading = false
  }
}
</script>
